import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// No StrictMode: its dev-only double effect invocation would double-fire register().
ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
